import MonacoEditor from "@monaco-editor/react";
import { Component } from "react";
import { datasetData } from "../../Datasets/NewDatasetSignals";
import { template } from "../../Entry/Manage/EditEntrySignals";
import { templateData } from "../../Template/NewTemplateSignals";

export class CodeEditor extends Component {
  constructor({ initialCode, language, type }) {
    super();
    this.state = {
      code:
        typeof initialCode === "object" ? JSON.stringify(initialCode, null, 2) : initialCode || "",
      language: language || "json",
      type: type,
    };
  }

  render() {
    return (
      <div className="!k-h-full !k-w-full !k-p-0 !k-m-0">
        <MonacoEditor
          height="100%"
          language={this.state.language || "json"}
          value={this.state.code}
          onChange={(value) => {
            this.setState({ code: value });
            try {
              if (this.state.type === "Template") {
                templateData.value = JSON.parse(value);
              }
              if (this.state.type === "Dataset") {
                datasetData.value = JSON.parse(value);
              }
              if (this.state.type === "Entry") {
                template.value = JSON.parse(value);
              }
            } catch (error) {
              console.error("Error parsing JSON:", error);
            }
          }}
          onMount={this.handleEditorDidMount}
          theme="vs-dark"
          options={{
            minimap: { enabled: true },
            scrollBeyondLastLine: false,
            fontSize: 14,
            fontFamily: '"Fira code", "Fira Mono", monospace',
            automaticLayout: true,
            formatOnPaste: true,
            formatOnType: true,
            stickyScroll: { enabled: false },
            codeLens: { enabled: false },
          }}
        />
      </div>
    );
  }
}
